/* eslint-disable */

var commonjsGlobal =
  typeof globalThis !== 'undefined'
    ? globalThis
    : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
        ? global
        : typeof self !== 'undefined'
          ? self
          : {}

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x
}

var bankverify_umdExports = {}
var bankverify_umd = {
  get exports() {
    return bankverify_umdExports
  },
  set exports(v) {
    bankverify_umdExports = v
  },
}

;(function (module, exports) {
  !(function (e, t) {
    module.exports = t()
  })(commonjsGlobal, () =>
    (function (e) {
      function t(r) {
        if (n[r]) return n[r].exports
        const a = (n[r] = { exports: {}, id: r, loaded: !1 })
        return (e[r].call(a.exports, a, a.exports, t), (a.loaded = !0), a.exports)
      }
      var n = {}
      return ((t.m = e), (t.c = n), (t.p = './dist/'), t(0))
    })([
      function (e, t, n) {
        function r(e) {
          return e && e.__esModule ? e : { default: e }
        }
        ;(Object.defineProperty(t, '__esModule', { value: !0 }), (t.init = void 0))
        const a = n(1)
        const i = r(a)
        const u = n(8)
        const l = r(u)
        const s = n(9)
        const o = r(s)
        typeof Object.create !== 'function' &&
          (Object.create = (function () {
            const e = function () {}
            return function (t) {
              if (arguments.length > 1) throw Error('Second argument not supported')
              if (t !== Object(t) && t !== null) throw new TypeError('Argument must be an object or null')
              if (t === null) throw Error('null [[Prototype]] not supported')
              e.prototype = t
              const n = new e()
              return ((e.prototype = null), n)
            }
          })())
        const d = function (e) {
          const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'account'
          let n = void 0
          switch (t) {
            case 'bankgiro':
              n = Object.create(l.default)
              break
            case 'plusgiro':
              n = Object.create(o.default)
              break
            case 'account':
              n = Object.create(i.default)
          }
          if (!n) throw new Error('Invalid account type')
          return (n.init(e), n)
        }
        t.init = d
      },
      function (e, t, n) {
        function r(e) {
          return e && e.__esModule ? e : { default: e }
        }
        Object.defineProperty(t, '__esModule', { value: !0 })
        const a = n(2)
        const i = r(a)
        const u = n(3)
        const l = r(u)
        const s = n(4)
        const o = r(s)
        const d = n(5)
        const f = r(d)
        const h = n(7)
        const c = r(h)
        const m = {
          accountNumber: void 0,
          init(e) {
            return ((this.accountNumber = e), this)
          },
          valid() {
            return !this.errors().length
          },
          errors: function e() {
            const e = []
            return (
              this.serialNumber().length < this.serialNumberLength().min && e.push(o.default.TOO_SHORT),
              this.serialNumber().length > this.serialNumberLength().max && e.push(o.default.TOO_LONG),
              this.getAccountNumber().match(/[^\d -\.]/) && e.push(o.default.INVALID_CHARACTERS),
              this.shouldValidate() && !this.validateSerial() && e.push(o.default.BAD_CHECKSUM),
              void 0 === this.bankData().name && e.push(o.default.UNKNOWN_CLEARING_NUMBER),
              e
            )
          },
          getAccountNumber() {
            return this.accountNumber
          },
          normalize() {
            return this.valid() ? [this.clearingNumber(), this.serialNumber()].join('-') : this.getAccountNumber()
          },
          bank() {
            return this.bankData().name
          },
          bankData() {
            const e = parseInt(this.digits().substr(0, 4), 10)
            const t = i.default.find((t) => {
              const n = t.interval.split('..')
              const r = parseInt(n[0], 10)
              const a = parseInt(n[1], 10)
              return r <= e && e <= a
            })
            return t || {}
          },
          serialNumber() {
            const e = this.digits().slice(this.clearingNumberLength())
            return e.length === 0 ? e : this.zeroFill() ? (0, f.default)(e, this.serialNumberLength().min, 0) : e
          },
          serialNumberLength() {
            return {
              min: this.bankData().minLength || this.DEFAULTS.MIN_LENGTH,
              max: this.bankData().maxLength || this.bankData().minLength || this.DEFAULTS.MAX_LENGTH,
            }
          },
          shouldValidate() {
            return this.bankData().type && !!this.bankData().type.algorithm
          },
          validateSerial() {
            return (
              !(this.bankData().type.algorithm === 'mod10' && !c.default.mod10(this.validationNumbers())) &&
              !(this.bankData().type.algorithm === 'mod11' && !c.default.mod11(this.validationNumbers()))
            )
          },
          validationNumbers() {
            const e = this.bankData().type.weightedNumbers
            const t = this.bankData().type
            let n = void 0
            return (
              (t !== l.default.TYPE1 && t !== l.default.TYPE2) || (n = this.digits().slice(-e)),
              (t !== l.default.TYPE3 && t !== l.default.TYPE4 && t !== l.default.TYPE5) ||
                (n = this.serialNumber().slice(-e)),
              n
            )
          },
          clearingNumber() {
            return [this.digits().substr(0, 4), this.checksumForClearing() ? this.digits().substr(4, 1) : null]
              .filter((e) => e)
              .join('-')
          },
          clearingNumberLength() {
            return this.checksumForClearing() ? 5 : 4
          },
          checksumForClearing() {
            if (this.bankData().checksumForClearing) {
              if (this.bank() !== 'Swedbank') return !0
              const e = this.digits()
              return c.default.mod10(e.substr(5))
            }
            return !1
          },
          digits() {
            return this.getAccountNumber().replace(/\D/g, '')
          },
          zeroFill() {
            return this.bankData().zerofill || !1
          },
          DEFAULTS: Object.freeze({ MIN_LENGTH: 7, MAX_LENGTH: 7 }),
        }
        t.default = m
      },
      function (e, t, n) {
        function r(e) {
          return e && e.__esModule ? e : { default: e }
        }
        Object.defineProperty(t, '__esModule', { value: !0 })
        const a = n(3)
        const i = r(a)
        const u = [
          { interval: '1100..1199', name: 'Nordea', type: i.default.TYPE1 },
          { interval: '1200..1399', name: 'Danske Bank', type: i.default.TYPE1 },
          { interval: '1400..2099', name: 'Nordea', type: i.default.TYPE1 },
          { interval: '2300..2399', name: 'Ålandsbanken', type: i.default.TYPE2 },
          { interval: '2400..2499', name: 'Danske Bank', type: i.default.TYPE1 },
          { interval: '3000..3299', name: 'Nordea', type: i.default.TYPE1 },
          {
            interval: '3300..3300',
            name: 'Nordea',
            type: i.default.TYPE3,
            minLength: 10,
          },
          { interval: '3301..3399', name: 'Nordea', type: i.default.TYPE1 },
          { interval: '3400..3409', name: 'Länsförsäkringar Bank', type: i.default.TYPE1 },
          { interval: '3410..3781', name: 'Nordea', type: i.default.TYPE1 },
          {
            interval: '3782..3782',
            name: 'Nordea',
            type: i.default.TYPE3,
            minLength: 10,
          },
          { interval: '3783..3999', name: 'Nordea', type: i.default.TYPE1 },
          { interval: '4000..4999', name: 'Nordea', type: i.default.TYPE2 },
          { interval: '5000..5999', name: 'SEB', type: i.default.TYPE1 },
          {
            interval: '6000..6999',
            name: 'Handelsbanken',
            type: i.default.TYPE4,
            maxLength: 9,
            minLength: 8,
          },
          { interval: '7000..7999', name: 'Swedbank', type: i.default.TYPE1 },
          {
            interval: '8000..8999',
            name: 'Swedbank',
            type: i.default.TYPE5,
            minLength: 10,
            checksumForClearing: !0,
            zerofill: !0,
          },
          { interval: '9020..9029', name: 'Länsförsäkringar Bank', type: i.default.TYPE2 },
          { interval: '9040..9049', name: 'Citibank', type: i.default.TYPE2 },
          { interval: '9060..9069', name: 'Länsförsäkringar Bank', type: i.default.TYPE1 },
          { interval: '9090..9099', name: 'Royal Bank of Scotland', type: i.default.TYPE2 },
          { interval: '9100..9109', name: 'Nordnet Bank', type: i.default.TYPE2 },
          { interval: '9120..9124', name: 'SEB', type: i.default.TYPE1 },
          { interval: '9130..9149', name: 'SEB', type: i.default.TYPE1 },
          { interval: '9150..9169', name: 'Skandiabanken', type: i.default.TYPE2 },
          { interval: '9170..9179', name: 'Ikano Bank', type: i.default.TYPE1 },
          {
            interval: '9180..9189',
            name: 'Danske Bank',
            type: i.default.TYPE3,
            minLength: 10,
          },
          { interval: '9190..9199', name: 'DNB Bank', type: i.default.TYPE2 },
          { interval: '9230..9239', name: 'Marginalen Bank', type: i.default.TYPE1 },
          { interval: '9250..9259', name: 'SBAB', type: i.default.TYPE1 },
          { interval: '9260..9269', name: 'DNB Bank', type: i.default.TYPE2 },
          { interval: '9270..9279', name: 'ICA Banken', type: i.default.TYPE1 },
          { interval: '9280..9289', name: 'Resurs Bank', type: i.default.TYPE1 },
          {
            interval: '9300..9349',
            name: 'Swedbank (fd. Sparbanken Öresund)',
            type: i.default.TYPE3,
            minLength: 10,
            zerofill: !0,
          },
          { interval: '9390..9399', name: 'Landshypotek AB', type: i.default.TYPE2 },
          { interval: '9400..9449', name: 'Forex Bank', type: i.default.TYPE1 },
          { interval: '9460..9469', name: 'Santander Consumer Bank AS', type: i.default.TYPE1 },
          { interval: '9470..9479', name: 'BNP Paribas Fortis Bank', type: i.default.TYPE2 },
          {
            interval: '9500..9549',
            name: 'Nordea/Plusgirot',
            type: i.default.TYPE5,
            maxLength: 10,
            minLength: 1,
          },
          { interval: '9550..9569', name: 'Avanza Bank', type: i.default.TYPE2 },
          {
            interval: '9570..9579',
            name: 'Sparbanken Syd',
            type: i.default.TYPE3,
            minLength: 10,
            zerofill: !0,
          },
          { interval: '9590..9599', name: 'Erik Penser AB', type: i.default.TYPE2 },
          { interval: '9630..9639', name: 'Lån & Spar Bank Sverige', type: i.default.TYPE1 },
          { interval: '9640..9649', name: 'Nordax Bank AB', type: i.default.TYPE2 },
          { interval: '9660..9669', name: 'Amfa Bank AB', type: i.default.TYPE2 },
          { interval: '9670..9679', name: 'JAK Medlemsbank', type: i.default.TYPE2 },
          { interval: '9680..9689', name: 'BlueStep Finans AB', type: i.default.TYPE1 },
          { interval: '9700..9709', name: 'Ekobanken', type: i.default.TYPE2 },
          { interval: '9880..9889', name: 'Riksgälden', type: i.default.TYPE2 },
          {
            interval: '9890..9899',
            name: 'Riksgälden',
            type: i.default.TYPE3,
            minLength: 10,
          },
          {
            interval: '9960..9969',
            name: 'Nordea/Plusgirot',
            type: i.default.TYPE5,
            maxLength: 10,
            minLength: 1,
          },
        ]
        t.default = u
      },
      function (e, t) {
        Object.defineProperty(t, '__esModule', { value: !0 })
        const n = {
          TYPE1: {
            algorithm: 'mod11',
            clearingLength: 4,
            serialLength: 7,
            weightedNumbers: 10,
          },
          TYPE2: {
            algorithm: 'mod11',
            clearingLength: 4,
            serialLength: 7,
            weightedNumbers: 11,
          },
          TYPE3: {
            algorithm: 'mod10',
            clearingLength: 4,
            serialLength: 10,
            weightedNumbers: 10,
          },
          TYPE4: {
            algorithm: 'mod11',
            clearingLength: 4,
            serialLength: 9,
            weightedNumbers: 9,
          },
          TYPE5: {
            algorithm: 'mod10',
            clearingLength: 5,
            serialLength: 10,
            weightedNumbers: 10,
          },
        }
        t.default = n
      },
      function (e, t) {
        Object.defineProperty(t, '__esModule', { value: !0 })
        const n = {
          TOO_SHORT: 'TOO_SHORT',
          TOO_LONG: 'TOO_LONG',
          INVALID_CHARACTERS: 'INVALID_CHARACTERS',
          BAD_CHECKSUM: 'BAD_CHECKSUM',
          UNKNOWN_CLEARING_NUMBER: 'UNKNOWN_CLEARING_NUMBER',
        }
        t.default = n
      },
      function (e, t, n) {
        /*!
         * pad-left <https://github.com/jonschlinkert/pad-left>
         *
         * Copyright (c) 2014-2015, Jon Schlinkert.
         * Licensed under the MIT license.
         */

        const r = n(6)
        e.exports = function (e, t, n) {
          return (
            (e = e.toString()),
            typeof t === 'undefined' ? e : ((n = n === 0 ? '0' : n ? n.toString() : ' '), r(n, t - e.length) + e)
          )
        }
      },
      function (e, t) {
        /*!
         * repeat-string <https://github.com/jonschlinkert/repeat-string>
         *
         * Copyright (c) 2014-2015, Jon Schlinkert.
         * Licensed under the MIT License.
         */

        function n(e, t) {
          if (typeof e !== 'string') throw new TypeError('expected a string')
          if (t === 1) return e
          if (t === 2) return e + e
          const n = e.length * t
          if (r !== e || typeof r === 'undefined') ((r = e), (a = ''))
          else if (a.length >= n) return a.substr(0, n)
          for (; n > a.length && t > 1; ) (1 & t && (a += e), (t >>= 1), (e += e))
          return ((a += e), (a = a.substr(0, n)))
        }
        let r
        var a = ''
        e.exports = n
      },
      function (e, t) {
        Object.defineProperty(t, '__esModule', { value: !0 })
        const n = {
          mod10(e) {
            const t = e
              .split('')
              .reverse()
              .reduce((e, t, n) => {
                const r = (n + 1) % 2 === 0 ? 2 : 1
                let a = parseInt(t, 10) * r
                return (a > 9 && (a -= 9), e + a)
              }, 0)
            return t % 10 === 0
          },
          mod11(e) {
            if (e.length > 11) return !1
            const t = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 1]
            const n = e
              .split('')
              .reverse()
              .reduce((e, n, r) => e + parseInt(n, 10) * t[r], 0)
            return n % 11 === 0
          },
        }
        t.default = n
      },
      function (e, t, n) {
        function r(e) {
          return e && e.__esModule ? e : { default: e }
        }
        Object.defineProperty(t, '__esModule', { value: !0 })
        const a = n(7)
        const i = r(a)
        const u = n(4)
        const l = r(u)
        const s = {
          number: void 0,
          init(e) {
            return ((this.number = e), this)
          },
          valid() {
            return !this.errors().length
          },
          errors: function e() {
            const e = []
            return (
              this.digits().length < 7 && e.push(l.default.TOO_SHORT),
              this.digits().length > 8 && e.push(l.default.TOO_LONG),
              this.getNumber().match(/[^\d -]/) && e.push(l.default.INVALID_CHARACTERS),
              i.default.mod10(this.digits()) || e.push(l.default.BAD_CHECKSUM),
              e
            )
          },
          normalize() {
            return this.valid()
              ? this.digits()
                  .split(/(\d{4})$/)
                  .slice(0, 2)
                  .join('-')
              : this.getNumber()
          },
          fundraising() {
            return this.valid() && this.digits().search(/^90[0-4]/) !== -1
          },
          getNumber() {
            return this.number || ''
          },
          digits() {
            return this.getNumber().replace(/\D/g, '')
          },
        }
        t.default = s
      },
      function (e, t, n) {
        function r(e) {
          return e && e.__esModule ? e : { default: e }
        }
        Object.defineProperty(t, '__esModule', { value: !0 })
        const a = (function () {
          function e(e, t) {
            const n = []
            let r = !0
            let a = !1
            let i = void 0
            try {
              for (
                var u, l = e[Symbol.iterator]();
                !(r = (u = l.next()).done) && (n.push(u.value), !t || n.length !== t);
                r = !0
              );
            } catch (e) {
              ;((a = !0), (i = e))
            } finally {
              try {
                !r && l.return && l.return()
              } finally {
                if (a) throw i
              }
            }
            return n
          }
          return function (t, n) {
            if (Array.isArray(t)) return t
            if (Symbol.iterator in Object(t)) return e(t, n)
            throw new TypeError('Invalid attempt to destructure non-iterable instance')
          }
        })()
        const i = n(7)
        const u = r(i)
        const l = n(4)
        const s = r(l)
        const o = {
          number: void 0,
          init(e) {
            return ((this.number = e), this)
          },
          valid() {
            return !this.errors().length
          },
          errors: function e() {
            const e = []
            return (
              this.digits().length < 2 && e.push(s.default.TOO_SHORT),
              this.digits().length > 8 && e.push(s.default.TOO_LONG),
              this.getNumber().match(/[^\d -]/) && e.push(s.default.INVALID_CHARACTERS),
              u.default.mod10(this.digits()) || e.push(s.default.BAD_CHECKSUM),
              e
            )
          },
          normalize() {
            if (this.valid()) {
              const e = this.digits().split(/(\d{2,6})?(\d)$/)
              const t = a(e, 3)
              const n = t[0]
              let r = t[1]
              const i = t[2]
              return (
                (r = r || ''),
                (r = r.split(/(\d\d)/).filter((e) => !!e.length)),
                [n, r.join(' '), '-', i].join('')
              )
            }
            return this.getNumber()
          },
          fundraising() {
            return this.valid() && this.digits().search(/^90/) !== -1
          },
          getNumber() {
            return this.number || ''
          },
          digits() {
            return this.getNumber().replace(/\D/g, '')
          },
        }
        t.default = o
      },
    ]),
  )
})(bankverify_umd)

var BankVerify = /*@__PURE__*/ getDefaultExportFromCjs(bankverify_umdExports)

export { BankVerify as default }
